import Img from './Img';
import styles from './topLogo.module.scss';
import { useRouter } from 'next/router';

export default () => {
  const router = useRouter();
  const isWingDomain = typeof window !== 'undefined' && window.location.hostname.includes('wingapp');

  if (isWingDomain) {
    return null;
  }

  return (
    <div className={styles.logo}>
      <Img
        src="https://cdn.duetapp.net/v1/images/eyJpZCI6IkRFSjdIVkNaTktWQ1Q0NVNXT0g1RkRCWFZDQjZMSiIsInciOjI0MCwiaCI6NzIsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoxNzM4MzkwMTQ2MjQzNjQ4ODJ9"
        onClick={() => router.push('/')}
      />
    </div>
  );
};
